import { Close } from '@material-ui/icons'
import { useTheme } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'


export default function CloseButton({ closePopupWindow }) {
    const { t } = useTranslation()
    const { theme: { bgColors, colors } } = useTheme()
    return (
        <button className={`border-0 d-flex align-items-center justify-content-center`} style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: bgColors.bgBoxes }} onClick={() => closePopupWindow()} onMouseDown={e => e.stopPropagation()} data-close-modal aria-label={t('close')}>
            <Close style={{ fill: colors.colorText, fontSize: '16px' }} />
        </button>
    )
}
